<template>
  <p class="clearfix mb-0" style="margin: 0px;">
    <!-- <span class="float-md-right d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="https://consumerinsearch.com/" target="_blank">UPTRENIX</b-link>
      <span class="d-none d-sm-inline-block">, All Rights Reserved</span>
    </span> -->
  </p>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
  components: {
    BLink,
  },
};
</script>

<style>
.footer {
  min-height: 0rem !important;
  padding: 0.5rem 1.5rem !important;
}
</style>
